// @flow
import { styled } from 'mz-ui-kit'

// Container for the lightbox window
export const Container = styled('div', {
  position: 'fixed',
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  outline: 0,
  display: 'flex',
  flexFlow: 'column nowrap',
  overflowX: 'hidden',
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch',
})

// Gray overlay
export const Overlay = styled<{
  $showed?: boolean,
}>('div', ({ $showed }) => ({
  position: 'fixed',
  width: '100%',
  height: '100%',
  opacity: $showed ? 1 : 0,
  transition: 'all 650ms cubic-bezier(0.165, 0.84, 0.44, 1)',
  backgroundColor: 'rgba(0,0,0,0.6)',
  zIndex: 0,
}))

// Window wrapper to center the window
export const WindowWrapper = styled<{
  $showed?: boolean,
}>('div', ({ $showed }) => ({
  alignSelf: 'center',
  opacity: $showed ? 1 : 0,
  transform: $showed ? 'translateY(0)' : 'translateY(50px)',
  transition: 'all 650ms cubic-bezier(0.165, 0.84, 0.44, 1)',
  position: 'relative',
  margin: 'auto',
}))

// Lighbox window
export const Window = styled<{}>('div', ({ $palette }) => ({
  position: 'relative',
  margin: '40px',
  borderRadius: '3px',
  boxShadow: '0px 3px 6px 0px rgba(0,0,0,0.45)',
  backgroundColor: `${$palette('white')}`,
}))

// Button to close the lightbox
export const CloseButton = styled<{}>('div', ({ $palette }) => ({
  transition: `opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1)`,
  position: 'absolute',
  cursor: 'pointer',
  fontSize: '24px',
  padding: '15px',
  right: '-10px',
  top: '22px',
  zIndex: 1,
  lineHeight: '24px',
  color: `${$palette('white')}`,
  opacity: 0.5,
  ':hover': {
    opacity: 1,
  },
  ':after': {
    content: '"✕"',
    display: 'block',
  },
}))

export const Header = styled('div', {
  padding: `20px`,
  backgroundColor: '#f3f3ec',
  display: 'flex',
  flexFlow: 'column nowrap',
})

export const Title = styled('h1', {
  margin: '0',
  padding: '0',
  fontSize: '20px',
})

export const Subtitle = styled('h2', {
  margin: '0',
  padding: '0',
  fontSize: '18px',
  fontWeight: 400,
})
